import { put, call, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/financialTransferAccounts'
import { getTransferAccounts as getTransferAccountsService } from 'services'

const {
  FINANCIAL_TRANSFER_ACCOUNTS_REQUEST,
  FINANCIAL_TRANSFER_ACCOUNTS_SUCCESS,
  FINANCIAL_TRANSFER_ACCOUNTS_ERROR
} = ACTION_TYPES

export function *getAccounts() {
  try {
    const response = yield call(getTransferAccountsService)
    yield put({ type: FINANCIAL_TRANSFER_ACCOUNTS_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: FINANCIAL_TRANSFER_ACCOUNTS_ERROR, payload: err })
  }
}

export default function *watchFinancialTransferAccounts() {
  yield takeLatest(FINANCIAL_TRANSFER_ACCOUNTS_REQUEST, getAccounts)
}
